import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { Segment, Form, Button, Header, Input, Message, Icon } from "semantic-ui-react";
import PropTypes from "prop-types";
import UserStore from "~/stores/UserStore";
import PromiseButton from "~/components/element/PromiseButton";
import { getValidationErrors } from "~/utils/ReactReformed/ValidateSchema";
import FormStore from "~/stores/FormStore";

const validationRules = {
  password: {
    required: true,
    minLength: 4,
  },
  confirmPassword: {
    required: true,
    callback: (value, { password }) => {
      if (value !== password) {
        return "passwords must match";
      }

      return null;
    },
  },
};

@observer
class ChangePassword extends Component {
  @observable formStore = null;

  constructor(props) {
    super(props);

    this.formStore = new FormStore({ password: "", confirmPassword: "" });

    this.state = {
      saved: false,
    };
  }

  submit() {
    const { userStore } = this.props;
    const { model } = this.formStore;

    return userStore
      .save({ password: model.password })
      .then(() => {
        this.setState({ saved: true });
      })
      .finally(() => {
        this.formStore.reset();
      });
  }

  render() {
    const { close, t } = this.props;
    const { saved } = this.state;
    const { model, setProperty, getAggregatedError, onBlur, isDirty } = this.formStore;

    const validation = getValidationErrors(validationRules, model, this.props);

    return (
      <>
        {!saved ? (
          <Segment placeholder>
            <Header icon>{t("changePassword")}</Header>
            <Form.Field
              control={Input}
              name="password"
              type="password"
              label={t("newPassword")}
              value={model.password}
              onBlur={onBlur}
              onChange={e => setProperty("password", e.target.value)}
              error={getAggregatedError("password", validation)}
            />
            <Form.Field
              control={Input}
              name="confirmPassword"
              type="password"
              label={t("confirmNewPassword")}
              value={model.confirmPassword}
              onBlur={onBlur}
              onChange={e => setProperty("confirmPassword", e.target.value)}
              error={getAggregatedError("confirmPassword", validation)}
            />
            <Segment.Inline>
              <PromiseButton
                style={{ margin: "0px 1.5rem 0px 0px" }}
                primary
                disabled={!isDirty || !validation.isValid}
                onClick={() => this.submit()}
              >
                {t("update")}
              </PromiseButton>
              <Button onClick={close}>{t("cancel")}</Button>
            </Segment.Inline>
          </Segment>
        ) : (
          <Message color="green">
            <Message.Header>{t("passwordChanged")}</Message.Header>
            <p>{t("newPasswordSaved")}</p>
            <Button icon onClick={close}>
              <Icon name="close" />
              <span>{t("close")}</span>
            </Button>
          </Message>
        )}
      </>
    );
  }
}
ChangePassword.propTypes = {
  userStore: PropTypes.instanceOf(UserStore),
  close: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(ChangePassword);
